import I18n from 'core/i18n'
import * as React from 'react'
import styled from 'styled-components'
import { withHtmlTag } from '../../utils'
import * as constants from '../../static/constants'
import { debounce } from 'lodash'
interface IProps {
  text: string
  showMoreHandler: () => void
  className?: string
}
const TextWrapStyle = styled.div`
  .Content {
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
    font-size: 1.4rem;
    line-height: 1.5;
    max-height: 4.5em;
  }

  .Content_Toggle {
    display: inline-block;
    font-size: 1.4rem;
    text-decoration: underline;
    text-transform: capitalize;
    color: ${constants.COLORS.primary};
    cursor: pointer;
    &:hover {
      text-decoration: none;
    }
  }
`

export const TextWrapAlt: React.FC<IProps> = ({ text, className = '', showMoreHandler }) => {
  const bodyRef = React.useRef<HTMLDivElement>(null)
  const [isOverflowing, setIsOverflowing] = React.useState(false)

  React.useLayoutEffect(() => {
    if (!bodyRef.current) {
      return
    }

    const resizeHandler = debounce(() => {
      const el = bodyRef.current
      setIsOverflowing(el.scrollHeight > el.clientHeight)
      return
    }, 100)
    window.addEventListener('resize', resizeHandler)

    resizeHandler()

    return () => {
      window.removeEventListener('resize', resizeHandler)
      resizeHandler.cancel()
    }
  }, [text])

  const onClick = () => {
    if (showMoreHandler) {
      showMoreHandler()
    }
  }

  return (
    <TextWrapStyle>
      <div className={`Content ${className}`} ref={bodyRef}>
        <div dangerouslySetInnerHTML={{ __html: withHtmlTag(text) }} />
      </div>
      {isOverflowing && (
        <div className="Content_Toggle" onClick={onClick}>
          {I18n.t('generic.show_more')}
        </div>
      )}
    </TextWrapStyle>
  )
}
